export const wheelWidth = 460;
export const wheelHeight = 460;
export const wheelDotRadius = 6;
export const wheelLogoRadius = 30;
export const wheelLogoStrokeWidth = 1.5;
export const animationDuration = 24;
export const circleCenter = { x: wheelWidth / 2, y: wheelHeight / 2 };
export const viewBox = `0 0 ${wheelWidth} ${wheelHeight}`;
export const circleRadius = wheelWidth / 2 - wheelLogoRadius;
